/**
 * 消息 公告 banner 的操作
 */
import { defineStore } from 'pinia';
import { useHot } from '../useHot';
import network from '../network';
import { dayEndTimeNew, dayStartTimeNew, getDeviceType, getJSON, getLocalStorage, setJSON } from '@star/utils';
import dayjs from 'dayjs';

export const useMsgStore = defineStore({
  id: 'message',
  state: () => {
    return {
      banners: [] as any[], // banner图
      banners2: [] as any[], // banner图2 我的
      newLists: [], // 公告
      gameNewsLists: [], // 游戏公告
      feedbackList: [], // 用户反馈
      activeformquery: [],
      activeTaskType: null,
      reqNewListFinish: false,
      webNewsUnread: 0, // 未读站内信
      unreadMessage: getJSON('unreadMessage', true) || 0, // 未读收件箱
      unreadFeedback: getJSON('unreadFeedback', true) || 0, // 未读问题反馈
      unreadMymessage: getJSON('unreadMymessage', true) || 0, // 未读我的消息
      enquiryActivityApplication: '', // 优惠申请查询
      dtycj: {
        isCanOpenDtycj: false, // 用于控制是否能进入答题赢彩金的
        datiNum: 0, // 答题次数
      },
    };
  },
  getters: {
    unreadMessageTotal: state => {
      const total = state.unreadMessage + state.unreadMymessage + state.unreadFeedback;
      return total > 99 ? '99+' : total;
    },
  },
  actions: {
    setBanners(data) {
      this.banners = data;
    },
    setBanners2(data) {
      this.banners2 = data;
    },
    setNewLists(data) {
      this.newLists = data;
    },
    setFeedbackLists(data) {
      this.feedbackList = data;
    },
    setGameNewsLists(data) {
      this.gameNewsLists = data;
    },
    setReqNewListFinish(data) {
      this.reqNewListFinish = data;
    },
    setWebNewsUnread(data) {
      this.webNewsUnread = data;
    },
    setActiveTaskType(type) {
      this.activeTaskType = type;
    },
    setIsCanOpenDtycj(data) {
      this.dtycj.isCanOpenDtycj = data;
    },
    setUnreadMessage(num: number) {
      this.unreadMessage = num;
      setJSON('unreadMessage', num, true);
    },
    setUnreadFeedback(num: number) {
      this.unreadFeedback = num;
      setJSON('unreadFeedback', num, true);
    },
    setUnreadMymessage(num: number) {
      this.unreadMymessage = num;
      setJSON('unreadMymessage', num, true);
    },
    // 幸运注单: 验证
    async reqXyzdVeri() {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 322956,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 请求首页banner
     * */
    async reqBanners(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      if (!tenantInfo.value.tid) return;
      // 发起请求
      let data = {
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 999,
        state: 1,
        message_id: payload.message_id || 12, // banner 为12
        sort_flag: 1,
        tid: tenantInfo.value.tid,
        proxy: tenantInfo.value.proxy,
        chan_con: payload.chan_con,
        apply: payload.apply,
        location: '1',
        type: getDeviceType(),
        language: payload.language || Number(getLocalStorage('languageNum') || 0),
        ...payload,
      };
      try {
        const res: any = await network.request({
          cmdId: 380232,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          this.setBanners(res.data.data || []);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    async reqBanners2(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      if (!tenantInfo.value.tid) return;
      // 发起请求
      let data = {
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 999,
        state: 1,
        message_id: payload.message_id || 12, // banner 为12
        sort_flag: 1,
        tid: tenantInfo.value.tid,
        proxy: 0,
        chan_con: payload.chan_con,
        apply: payload.apply,
        type: getDeviceType(),
        location: '2',
        language: payload.language || Number(getLocalStorage('languageNum') || 22),
        ...payload,
      };
      console.log('getBanner2', data);
      try {
        const res: any = await network.request({
          cmdId: 380232,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          this.setBanners2(res.data.data || []);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 获取公告
     * ma_id: payload.ma_id,
     * */
    async reqNewList(payload: any = {}, nosave?) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      if (!tenantInfo.value.tid) return;
      // 发起请求
      let data = {
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 15,
        state: 1,
        message_id: payload.message_id || 10, // 公告 为10, 17=游戏公告
        sort_flag: 1,
        tid: tenantInfo.value.tid,
        proxy: tenantInfo.value.proxy,
        chan_con: payload.chan_con,
        apply: payload.apply,
        type: getDeviceType(),
        vip_level: userInfo.value.cust_level || 0,
        language: payload.language || Number(getLocalStorage('languageNum') || 0),
        ...payload,
      };
      try {
        const res: any = await network.request({
          cmdId: 380232,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (+data.message_id === 17) {
          this.setReqNewListFinish(true);
        }
        if (res && res.type === 'success') {
          let _data = res.data.data;
          if (!nosave) {
            this.setNewLists(_data || []);
          }
          res.data.data = _data;
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        if (+data.message_id === 17) {
          this.setReqNewListFinish(true);
        }
        return Promise.reject(error.data);
      }
    },

    /*
     * 获取站内信未读数量
     * */
    async reqWebMessageUnread(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 375024,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          this.webNewsUnread = res.data.countAll - res.data.redCount;
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 获取消息未读数量
     * */
    async reqMessageUnread(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        // 380337接口参数
        receivor_id: userInfo.value.cust_id,
        message_id: 30,
        receivor_type: 1,
        begin_time: dayjs().subtract(29, 'day').startOf('day').valueOf(),
        end_time: dayjs().endOf('day').valueOf(),
      };
      try {
        const res: any = await network.request({
          cmdId: 375026,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          this.setUnreadMessage(res.data.unreadCount || 0);
          this.setUnreadFeedback(res.data.feedbackCornerCount || 0);
          this.setUnreadMymessage(res.data.messageInstsCount || 0);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 站内信 收件箱
     * */
    async reqWebNews(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 375012,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 站内信 我的消息列表
     * */
    async reqMyNews(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        begin_time: dayStartTimeNew(Date.now() - 30 * 24 * 3600 * 1000),
        end_time: dayEndTimeNew(Date.now() + 3600 * 24 * 1000 * 2),
        ...payload,
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 10,
        tid: tenantInfo.value.tid,
        receivor_id: userInfo.value.cust_id,
        message_id: 30,
        receivor_type: 1,
      };
      try {
        const res: any = await network.request({
          cmdId: 380336,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });

        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    /*
     * 站内信 我的未读消息
     * */
    async reqMyNewsCount(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        begin_time: dayStartTimeNew(Date.now() - 30 * 24 * 3600 * 1000),
        end_time: dayEndTimeNew(Date.now() + 3600 * 24 * 1000 * 2),
        ...payload,
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 10,
        tid: tenantInfo.value.tid,
        receivor_id: userInfo.value.cust_id,
        message_id: 30,
        receivor_type: 1,
      };
      try {
        const res: any = await network.request({
          cmdId: 380337,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });

        console.log(res, 'res123');
        if (res && res.type === 'success') {
          this.unreadMymessage = res.data || 0;
          setJSON('unreadMymessage', this.unreadMymessage, true);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    /*
     * 站内信 设置我的消息
     * @param payload.type type1单个已读/删除 type2批量已读/批量删除
     */
    async setMyNews(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data: any = {
        tid: tenantInfo.value.tid,
        state: payload.state,
      };
      if (payload.type === 1) {
        data.message_inst_id = payload.message_inst_id;
        data.part_mon = payload.part_mon;
      } else {
        data.receivor_id = userInfo.value.cust_id;
        data.begin_time = dayStartTimeNew(Date.now() - 30 * 24 * 3600 * 1000);
        data.end_time = dayEndTimeNew(Date.now() + 3600 * 24 * 1000 * 2);
        data.receivor_type = 1;
        data.message_id = 30;
      }
      try {
        const res: any = await network.request({
          cmdId: payload.type === 1 ? 380335 : 380334,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 站内信 发送消息
     */
    async sendMessage(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let receivor = userInfo.value.cust_name;
      if (payload.data_type === 1) {
        receivor = payload.receivor;
      } else if (payload.data_type === 7) {
        receivor = 'system';
      }
      // 发起请求
      let data = {
        ...payload,
        theme: payload.theme,
        content: payload.content,
        data_type: payload.data_type,
        tid: tenantInfo.value.tid,
        from_user: userInfo.value.cust_name,
        addresseeName: receivor,
      };
      try {
        const res: any = await network.request({
          cmdId: 375017,
          data: data,
          headerType: 2,
          paramType: 1,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 问题反馈列表
     * */
    async reqFeedbackLists(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 375012,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 问题反馈一键领取
     */
    async receiveAllGiftAmount() {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 375033,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 问题反馈单个领取
     */
    async receiveGiftAmountSinge(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        mail_id: payload.mail_id,
        reply_id: payload.reply_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 390208,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 问题反馈一键已读
     * */
    async feedbackReadAll(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 375016,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 问题反馈详情
     * */
    async getFeedbackDetail(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
      };
      try {
        const res: any = await network.request({
          cmdId: 375031,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 问题反馈-再次反馈
     */
    async sendMessageAgain(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
      };
      try {
        const res: any = await network.request({
          cmdId: 375025,
          data: data,
          headerType: 2,
          paramType: 1,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 站内信 获取站内信详情
     */
    async reqMessageDetail(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      // 发起请求
      let data = {
        ...payload,
        mail_id: payload.mail_id,
        put_cust_name: payload.put_cust_name,
        send_cust_name: payload.send_cust_name,
        tid: tenantInfo.value.tid,
      };
      try {
        const res: any = await network.request({
          cmdId: 375023,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /*
     * 站内信 设置收件箱信息状态
     */
    async setWebNews(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 发起请求
      let data = {
        ...payload,
        type: payload.type,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      if (!payload.isAll) {
        data.mail_id = payload.mail_id;
        data.put_cust_name = payload.put_cust_name;
        data.send_cust_name = payload.send_cust_name;
      }
      try {
        const res: any = await network.request({
          cmdId: 375011,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    /*
     * 站内信 回复收件箱信息状态
     */
    async responseMessage(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      // 发起请求
      let data = {
        ...payload,
        send_cust_name: payload.send_cust_name,
        put_cust_name: payload.put_cust_name,
        mail_id: payload.mail_id,
        reply_content: payload.reply_content,
        tid: tenantInfo.value.tid,
      };
      try {
        const res: any = await network.request({
          cmdId: 375018,
          data: data,
          headerType: 2,
          paramType: 1,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    // 领取金币
    async getMsgCoin(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;

      let data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        ...payload,
      };
      try {
        const res: any = await network.request({
          cmdId: 390207,
          data: data,
          headerType: 2,
          paramType: 0,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
  },
});
